import {
  Alert,
  BottomSheetDialog,
  Button,
  ButtonBorder,
  Div,
  HeaderBack,
  InputItem,
  Label,
  Toast,
} from 'components';
import ComCheck from 'components/ComCheck';
import {Ecolors} from 'constant';
import React, {useEffect, useRef, useState} from 'react';
import {Platform} from 'react-native';
import {ScrollView} from 'react-native-gesture-handler';
import ImageResizer from 'react-native-image-resizer';
import {useSafeAreaInsets} from 'react-native-safe-area-context';
import {useDispatch} from 'react-redux';
import {getInfo} from 'reducer/authen';
import ComActionUpload from 'screens/MainScreen/DigitalSignature/ComActionUpload';
import {apiAuth, navigate} from 'services';
import {useAppSelector} from 'store/hooks';
import {
  getImageCamera,
  getImageLibrary,
  getUuid,
  parseMultilanguage,
} from 'utils';
import SignatureDraw from '../DigitalSignature/SignatureDraw';

function Lbl(p: {
  content: string;
  marginTop?: number;
  reverse?: boolean;
  multilanguage?: boolean;
}) {
  if (p.reverse) {
    return (
      <Label size={14} marginTop={p.marginTop || 0} multilanguage={false}>
        {`(`}
        <Label size={14} multilanguage={false} color={Ecolors.red}>
          *
        </Label>
        {`) `}
        <Label size={14} multilanguage={false}>
          {p.content}
        </Label>
      </Label>
    );
  }
  return (
    <Label marginTop={p.marginTop || 0} multilanguage={false}>
      <Label>{p.content}</Label>
      {` (`}
      <Label multilanguage={false} color={Ecolors.red}>
        *
      </Label>
      {`)`}
    </Label>
  );
}

function BtnCheckIndivisual(p: {
  title: string;
  onPress: (t: any) => void;
  keyCode: number;
  agentTypeCode: number;
}) {
  const {title, onPress, keyCode, agentTypeCode} = p;
  return (
    <Button
      onPress={() => {
        onPress(keyCode);
      }}
      width={163}
      height={48}
      borderRadius={5}
      borderColor={Ecolors.bordercolor}
      borderWidth={0.8}
      flexDirection="row"
      alignItems="center"
      justifyContent="flex-start"
      paddingHorizontal={15}>
      <Div
        widthHeight={20}
        alignItems="center"
        justifyContent="center"
        borderRadius={20}
        borderWidth={0.8}
        borderColor={Ecolors.bordercolor}>
        {keyCode == agentTypeCode && (
          <Div
            widthHeight={12}
            borderRadius={12}
            backgroundColor={Ecolors.mainColor}
          />
        )}
      </Div>
      <Label marginLeft={15}>{title}</Label>
    </Button>
  );
}

// Agent Balances : 1
// Indivisual :  2
function EditAgentcyInfoModal() {
  const dispatch = useDispatch();
  const [taxCode, setTaxCode] = useState('');
  const [agentCode, setAgentCode] = useState('');
  const [gadName, setGadName] = useState('');
  const [agentTypeCode, setAgentTypeCode] = useState<number>(1);
  const I18nState = useAppSelector(state => state.languages.I18nState);
  const bottomSheetUpload = useRef<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [isDisible, setIsDisible] = useState<boolean>(true);

  const agentCodeRef = useRef<any>();
  const gadNameRef = useRef<any>();

  const [isAccept, setIsAccept] = useState<boolean>(false);
  const [isErrorTaxCode, setIsErrorTaxCode] = useState<boolean>(false);
  const [isErrorAgentCode, setIsErrorAgentCode] = useState<boolean>(false);
  const [isErrorGadName, setIsErrorGadName] = useState<boolean>(false);

  const insets = useSafeAreaInsets();
  const bottomSheetDraw = useRef<any>(null);

  useEffect(() => {
    if (agentTypeCode == 1) {
      if (!!taxCode.length && !!agentCode.length && !!gadName && !!isAccept) {
        setIsDisible(false);
        return;
      }
      setIsDisible(true);
      return;
    }
    if (agentTypeCode == 2) {
      setGadName('');
      setAgentCode('');
      if (!!taxCode.length && !!isAccept) {
        setIsDisible(false);
        return;
      }
      setIsDisible(true);
      return;
    }
    return () => {};
  }, [taxCode, agentCode, gadName, agentTypeCode, isAccept]);

  const hide = (cb?: () => void) => {
    if (bottomSheetUpload.current) {
      bottomSheetUpload.current.hide().then(() => {
        if (cb) {
          cb();
        }
      });
    }
  };

  const onConfirm = async (data?: any) => {
    try {
      setLoading(true);
      const res = await apiAuth.createAgentcy(data);
      if (res.data?.otpInfo) {
        navigate('OtpRequestModal', {
          data: {
            requestOnSendOtp: res.data?.otpInfo,
            flowApp: 'CreateAgentcy',
          },
          onConfirm: () => {
            dispatch(getInfo({}));
            Alert.show({
              type: 2,
              titleClose: 'alert.dong',
              content: `alert.kythanhcong`,
              onConfirm: () => {
                navigate('AccountVerifyScreen');
              },
              onClose: () => {
                navigate('AccountVerifyScreen');
              },
              onCancel: () => {
                navigate('AccountVerifyScreen');
              },
            });
            return;
          },
        });
        return;
      }
      if (res.status == 200) {
        dispatch(getInfo({}));
        Alert.show({
          type: 2,
          titleClose: 'alert.dong',
          content: `alert.kythanhcong`,
          onConfirm: () => {
            navigate('AccountVerifyScreen');
          },
          onClose: () => {
            navigate('AccountVerifyScreen');
          },
          onCancel: () => {
            navigate('AccountVerifyScreen');
          },
        });
        return;
      }
      Alert.showError({
        content: I18nState == 'vi' ? res.message : res.messageEn,
        multilanguage: false,
        onPress: () => {
          navigate('AccountVerifyScreen');
        },
      });
    } catch (error: any) {
      Alert.showError({
        content: I18nState == 'vi' ? error.message : error.messageEn,
        multilanguage: false,
        onPress: () => {},
      });
      return;
    } finally {
      setLoading(false);
    }
  };

  const doAction = async (image: any) => {
    const formdata = new FormData();
    const id = getUuid();
    const resFetch = await fetch(image?.uri);
    const blob = await resFetch.blob();

    const fileImg = new File([blob], `${id}.png`, {
      type: 'image/png',
    });

    formdata.append('file', fileImg);
    formdata.append('taxCode', taxCode);
    formdata.append('agentCode', agentCode);
    formdata.append('gadName', gadName);
    formdata.append('agentTypeCode', agentTypeCode.toString());
    onConfirm(formdata);

    return;
  };

  const focusNextInput = (ref: any) => {
    if (ref && ref.current) {
      ref.current.focus();
    }
  };

  return (
    <Div height={'100%'} backgroundColor={Ecolors.whiteColor}>
      <HeaderBack
        type={2}
        loading={loading}
        titleRight={`accountverify.save`}
        onRightPress={() => {
          if (!taxCode.length || !agentCode.length || !gadName || !isAccept) {
            Alert.showError({
              content: `alert.vuilongnhapdayduthongtin`,
              onPress: () => {},
            });
            return;
          }
          bottomSheetUpload.current.show();
          return;
        }}
        title={`agentcy.dangkycongtacvien`}
      />
      <ScrollView>
        <Div paddingHorizontal={16}>
          <Lbl marginTop={7} content={`agentcy.chonloaidoitac`} />
          <Div
            flexDirection="row"
            alignItems="center"
            justifyContent="space-between"
            marginTop={7}>
            <BtnCheckIndivisual
              keyCode={2}
              agentTypeCode={agentTypeCode}
              onPress={(t: any) => setAgentTypeCode(t)}
              title={`agentcy.canhan`}
            />
            <BtnCheckIndivisual
              keyCode={1}
              agentTypeCode={agentTypeCode}
              onPress={(t: any) => setAgentTypeCode(t)}
              title={`agentcy.dailybaohiem`}
            />
          </Div>

          <Lbl marginTop={7} content={`agentcy.masothuecanhan`} />
          <InputItem
            marginTop={6}
            onChangeText={e => {
              if (isErrorTaxCode) {
                setIsErrorTaxCode(false);
              }
              setTaxCode(e);
            }}
            value={taxCode}
            marginHorizontal={0}
            keyboardType="decimal-pad"
            isError={isErrorTaxCode}
            titleError={`setpasswordscreen.thongtinkhongduocdetrong`}
            onSubmitEditing={() => {
              setIsErrorTaxCode(!taxCode.length);
              focusNextInput(agentCodeRef);
            }}
          />
          {agentTypeCode == 1 && (
            <>
              <Lbl marginTop={13} content={`agentcy.matuvan`} />
              <InputItem
                value={agentCode}
                onChangeText={a => {
                  if (isErrorAgentCode) {
                    setIsErrorAgentCode(false);
                  }
                  setAgentCode(a);
                }}
                marginHorizontal={0}
                marginTop={6}
                isError={isErrorAgentCode}
                titleError={`setpasswordscreen.thongtinkhongduocdetrong`}
                onSubmitEditing={() => {
                  setIsErrorAgentCode(!agentCode.length);
                  focusNextInput(gadNameRef);
                }}
                inputRef={agentCodeRef}
              />
              <Lbl marginTop={13} content={`agentcy.thuoctongdaily`} />
              <InputItem
                isError={isErrorGadName}
                titleError={`setpasswordscreen.thongtinkhongduocdetrong`}
                value={gadName}
                onChangeText={a => {
                  if (isErrorGadName) {
                    setIsErrorGadName(false);
                  }
                  setGadName(a);
                }}
                marginHorizontal={0}
                marginTop={6}
                onSubmitEditing={() => {
                  setIsErrorGadName(!gadName.length);
                }}
                inputRef={gadNameRef}
              />
            </>
          )}

          <Lbl
            reverse={true}
            multilanguage={false}
            marginTop={29}
            content={parseMultilanguage(`agentcy.content2`)}
          />
          {/* <ButtonDownloadAgentcyFile /> */}
        </Div>
      </ScrollView>
      <Div paddingHorizontal={16}>
        <ComCheck
          accept={isAccept}
          setIsAccept={() => {
            setIsAccept(!isAccept);
          }}
          content={parseMultilanguage(`agentcy.toidongy`)}
        />
      </Div>

      <Div
        flexDirection={'row'}
        marginBottom={insets.bottom + 20}
        alignItems={'center'}
        marginTop={10}
        paddingHorizontal={16}
        justifyContent={'space-between'}
        width={'100%'}>
        <ButtonBorder
          onPress={() => {}}
          width={166}
          height={48}
          title={`agentcy.desau`}
          type={2}
        />
        <ButtonBorder
          isDisable={isDisible}
          loading={loading}
          onPress={() => {
            bottomSheetUpload.current.show();
            return;
          }}
          width={166}
          height={48}
          title={`agentcy.kydientu`}
          type={1}
        />
      </Div>
      {/* draw sheet */}
      <BottomSheetDialog
        style={{
          flexDirection: 'column',
          flex: 1,
          alignItems: 'center',
          justifyContent: 'flex-end',
        }}
        ref={bottomSheetDraw}>
        <SignatureDraw
          flowApp={'CreateAgentcy'}
          callback={t => {
            doAction({
              uri: t,
            });
          }}
          onHide={() => {
            bottomSheetDraw.current.hide();
          }}
        />
      </BottomSheetDialog>
      {/* bottom sheet */}
      <BottomSheetDialog
        style={{
          flexDirection: 'column',
          flex: 1,
          alignItems: 'center',
          justifyContent: 'flex-end',
        }}
        ref={bottomSheetUpload}>
        <ComActionUpload
          isDrawline={true}
          onDrawline={() => {
            hide(() => {
              bottomSheetDraw.current.show();
            });
          }}
          onCancel={() => {
            hide();
          }}
          onCamera={async () => {
            // try {
            //   if (Platform.OS === 'ios') {
            //     await getImageCamera()
            //       .then((image: any) => {
            //         hide();
            //         if (image[0]) {
            //           doAction(image[0]);
            //         }
            //       })
            //       .catch(() => {
            //         hide();
            //       });
            //     return;
            //   }
            //   hide(async () => {
            //     getImageCamera()
            //       .then((image: any) => {
            //         if (image[0]) {
            //           doAction(image[0]);
            //         }
            //       })
            //       .catch(() => {
            //         hide();
            //       });
            //   });
            // } catch (error) {
            //   if (!!error) {
            //     Toast.show({
            //       content: 'alert.daxayraloi',
            //       multilanguage: true,
            //     });
            //   }
            // } finally {
            //   hide(async () => {});
            // }
          }}
          onGallery={async () => {
            try {
              if (Platform.OS === 'ios') {
                await getImageLibrary().then((image: any) => {
                  hide();
                  if (image[0]) {
                    if (image[0].uri.endsWith('.gif')) {
                      Alert.showError({
                        content: 'alert.dinhdanganhkhongphuhop',
                      });
                      return;
                    }
                    doAction(image[0]);
                  }
                });
                return;
              }
              hide(() => {
                console.log('hideee');
                getImageLibrary().then((image: any) => {
                  if (image[0]) {
                    if (image[0].uri.endsWith('.gif')) {
                      Alert.showError({
                        content: 'alert.dinhdanganhkhongphuhop',
                      });
                      return;
                    }
                    doAction(image[0]);
                  }
                });
              });
            } catch (error) {
              if (!!error) {
                Toast.show({
                  content: 'alert.daxayraloi',
                  multilanguage: true,
                });
                return;
              }
            } finally {
              hide(async () => {});
            }
          }}
        />
      </BottomSheetDialog>
    </Div>
  );
}

export default React.memo(EditAgentcyInfoModal);
